import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Tooltip } from 'antd'
import AddFitnessVideo from './add'
import EditFitnessVideo from './edit'
import DeleteFitnessVideo from './delete'
import PlayVideo from './play'
import FitnessVideoRibbon from './ribbon'
import MyIcon from '../../components/general/icon'

export default function FitnessVideo() {
  const [fitnessVideoData, setFitnessVideoData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAddFitnessVideoVisible, setIsAddFitnessVideoVisible] = useState(false)
  const [isEditFitnessVideoVisible, setIsEditFitnessVideoVisible] = useState(false)
  const [isDeleteFitnessVideoVisible, setIsDeleteFitnessVideoVisible] = useState(false)
  const [isPlayVideoVisible, setIsPlayVideoVisible] = useState(false)

  const initialConditions = {
    series_oid: '',
    keywords: '',
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getFitnessVideoData = () => {
    axios.post('/admin/content/fitness_video/list/get', { 
      keywords: filterValue.keywords,
      series_oid: filterValue.series_oid,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setFitnessVideoData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'videos': response.data.videos
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getFitnessVideoData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterValue, currentPage])

  const editFitnessVideo = (oid) => {
    setIsEditFitnessVideoVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteFitnessVideo = (oid, title) => {
    setIsDeleteFitnessVideoVisible(true)
    setPropsData({ oid: oid, title: title})
  }

  const playPlay = (filename) => {
    setIsPlayVideoVisible(true)
    setPropsData({ filename: filename})
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">健身视频</div>
            <FitnessVideoRibbon
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isAddVisible={() => { setIsAddFitnessVideoVisible(true) }}  
            />
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{width: '300px'}}>
                      <div className='public-main-style2-title'>标题</div>
                    </th>
                    <th>所属系列</th>
                    <th>视频时长</th>
                    <th>排序</th>
                    <th style={{width: '50px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {fitnessVideoData.videos && (fitnessVideoData.videos.length > 0 ? (fitnessVideoData.videos.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { editFitnessVideo(item.oid) }}>
                      <td style={{width: '300px'}}>
                        <div className='public-main-style2-tuwen'>
                          <img 
                            onClick={(event) => {event.stopPropagation(); playPlay(item.video_url)}}
                            style={{width: '100px', height: '80px', margin: '10px 15px 10px 0'}} 
                            src={item.cover_url} alt="" 
                          />
                          <span>{item.title}</span>
                        </div>
                      </td>
                      <th>{item.series_name}</th>
                      <th>{item.duration}分钟</th>
                      <td>{item.sort}</td>
                      <td style={{width: '50px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="删除">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); deleteFitnessVideo(item.oid, item.title)}}>
                              <MyIcon name='huishouzhan' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='4'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={fitnessVideoData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAddFitnessVideoVisible && <AddFitnessVideo
          getFitnessVideoData={getFitnessVideoData} 
          isOpen={isAddFitnessVideoVisible} 
          isCancel={() => { setIsAddFitnessVideoVisible(false) }} 
        />}

        {isEditFitnessVideoVisible && <EditFitnessVideo
          data={propsData}
          getFitnessVideoData={getFitnessVideoData} 
          isOpen={isEditFitnessVideoVisible} 
          isCancel={() => { setIsEditFitnessVideoVisible(false) }} 
        />}

        {isDeleteFitnessVideoVisible && <DeleteFitnessVideo
          data={propsData}
          getFitnessVideoData={getFitnessVideoData} 
          isOpen={isDeleteFitnessVideoVisible} 
          isCancel={() => { setIsDeleteFitnessVideoVisible(false) }} 
        />}

        {isPlayVideoVisible && <PlayVideo
          data={propsData}
          isOpen={isPlayVideoVisible} 
          isCancel={() => { setIsPlayVideoVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
